<template>
  <div ui-view="" class="app-body" id="view">
    <!-- ############ PAGE START-->
    <page-header title="사이트 관리" description="VMS 사이트 내부 보안서약서, 반입자산 종류, 체크리스트를 관리합니다.">
    </page-header>
    <div class="page-body ph-30">



      <div class="box mt-20">
        <div class="box-header">
          <!-- <h3>선택정보 입력</h3> -->

          <h4>보안 서약서 관리</h4>
          <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
          <small>보안 서약서 추가 및 편집이 가능합니다.</small>
          <div class="pt-16 pb-7">
            <button class="btn btn-md line-2 mr-6" @click="addTos()">추가</button>
          </div>
        </div>

        <div v-for="(item, index) in tosList">
          <hr v-if="index != 0" class="thin">
          <div class="box-body">
            <div class="form-group row">
              <div class="col-12 form-control-label">

                <label class="form-control-label mr-20">
                  <b style="color:#187ed6;">보안서약서 {{index + 1}}</b>
                </label>

                <!--<button class="btn btn-sm line-2">편집<i class="icon-edit ml-5"></i></button>-->
                <!--<button class="btn btn-sm line-2 ml-5">비활성화<i class="icon-stop ml-5"></i></button>-->
                <!--<button class="btn btn-sm line-2 ml-5">활성화<i class="icon-reset ml-5"></i></button>-->
                <button class="btn btn-sm line-2 ml-5">저장<i class="icon-check ml-5"></i></button>
                <button v-if="!item.tosIndex" class="btn btn-sm line-2 ml-5">취소<i class="icon-close ml-5"></i></button>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">타이틀</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" name="타이틀" class="form-control form-control-danger" v-model="item.tosTitle" :disabled="item.isEnable==0">
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">필수 여부</span>
              </label>
              <div class="col-6 pt-2">
                <dropdown v-model="item.isRequired" displayName="display" valueName="value" :datasource="isRequired" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)" :editMode="item.isEnable==1?false:item.isEnable"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">활성 여부</span>
              </label>
              <div class="col-6 pt-2">
                <dropdown v-model="item.isEnable" displayName="display" valueName="value" :datasource="isEnable" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">서약서 동의 텍스트</span>
              </label>
              <div class="col-6 pt-2">
                <input type="text" name="서약서 동의 텍스트" class="form-control form-control-danger" v-model="item.tosAgreeText" :disabled="item.isEnable==0"/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-2 form-control-label">
                <span class="">서약서 내용</span>
              </label>
              <div class="col-6 pt-2">
                <textarea class="form-control form-control-success" v-model="item.tosContents" style="height: 200px;" :disabled="item.isEnable==0"> </textarea>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="box mt-20">
        <div class="box-header">
          <!-- <h3>선택정보 입력</h3> -->

          <h4>반입 자산 종류 관리</h4>
          <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
          <small>방문객 반입 가능 자산 종류 추가가 및 활성/비활성 관리가 가능합니다.</small>
          <div class="pt-16 pb-7">
            <button class="btn btn-md line-2 mr-6" @click="addAsset()">추가</button>
            <button class="btn btn-md line-2 mr-6" @click="" disabled>수정</button>
          </div>
        </div>

        <div class="box-body pt-0">
          <div class="box-tbl mt-0">
            <table class="tbl no-outline no-shadow">
              <colgroup>
                <col width="42px">
                <col width="200px">
                <col width="auto">
                <col width="150px">
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <label class="md-check">
                      <input type="checkbox" class="has-value">
                      <i class="blue"></i>
                    </label>
                  </th>
                  <th>종류</th>
                  <th>설명</th>
                  <th>활성여부</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in assetList">
                  <td>
                    <label class="md-check">
                      <input type="checkbox" class="has-value">
                      <i class="blue"></i>
                    </label>
                  </td>
                  <td>{{ item.assetStr }}</td>
                  <td>{{ item.assetDescription }}</td>
                  <!--<td>{{ item.assetIsEnable }}</td>-->
                  <td class="td-compo-box">
                    <dropdown v-model="item.assetIsEnable" displayName="display" valueName="value" :datasource="isEnable" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)"/>
                  </td>
                </tr>
                <!--수정 -->
                <tr>
                  <td></td>
                  <td>
                    외장하드
                  </td>
                  <td>
                    <input type="text" name="설명" class="form-control" value="외장하드 디스크립션">
                  </td>
                  <td align="center">
                    <button class="btn btn-m"><i class="icon-check"></i></button>
                    <button class="btn btn-m ml-5"><i class="icon-close"></i></button>
                  </td>
                </tr>

                <!--추가-->
                <tr>
                  <td></td>
                  <td>
                    <input type="text" name="종류" class="form-control">
                  </td>
                  <td>
                    <input type="text" name="설명" class="form-control">
                  </td>
                  <td align="center">
                    <button class="btn btn-m"><i class="icon-check"></i></button>
                    <button class="btn btn-m ml-5"><i class="icon-close"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>


      <div class="box mt-20">
        <div class="box-header">
          <!-- <h3>선택정보 입력</h3> -->

          <h4>입실 체크리스트 관리</h4>
          <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
          <small>방문 예약 시, 방문 전 체크리스트 및 입실 시 체크리스트 목록 관리가 가능합니다.</small>
          <div class="pt-16 pb-7">
            <button class="btn btn-md line-2 mr-6" @click="">추가</button>
            <button class="btn btn-md line-2 mr-6" @click="" disabled>수정</button>
          </div>
        </div>

        <div class="box-body pt-0">
          <div class="box-tbl mt-0">
            <table class="tbl no-outline no-shadow">
              <colgroup>
                <col width="42px">
                <col width="200px">
                <col width="auto">
                <col width="auto">
                <col width="150px">
              </colgroup>
              <thead>
              <tr>
                <th>
                  <label class="md-check">
                    <input type="checkbox" class="has-value">
                    <i class="blue"></i>
                  </label>
                </th>
                <th>종류</th>
                <th>종류 설명</th>
                <th>내용</th>
                <th>활성여부</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in checkList">
                <td>
                  <label class="md-check">
                    <input type="checkbox" class="has-value">
                    <i class="blue"></i>
                  </label>
                </td>
                <td>{{ item.checkType.checkTypeStr }}</td>
                <td>{{ item.checkType.checkTypeDescription }}</td>
                <td>{{ item.contents }}</td>
                <td class="td-compo-box">
                  <dropdown v-model="item.isEnable" displayName="display" valueName="value" :datasource="isEnable" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)"/>
                </td>
              </tr>
              <!--수정 -->
              <tr>
                <td></td>
                <td >
                  <dropdown displayName="display" valueName="value" :isDropup="true" :datasource="checkType" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)"/>
                </td>
                <td colspan="2">
                  <input type="text" name="설명" class="form-control" placeholder="내용" value="보건당국으로부터 격리하도록 안내받은적이 없습니다.">
                </td>
                <td align="center">
                  <button class="btn btn-m"><i class="icon-check"></i></button>
                  <button class="btn btn-m ml-5"><i class="icon-close"></i></button>
                </td>
              </tr>
              <!--추가-->
              <tr>
                <td></td>
                <td >
                  <dropdown displayName="display" valueName="value" :isDropup="true" :datasource="checkType" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)"/>
                </td>
                <td colspan="2">
                  <input type="text" name="설명" class="form-control" placeholder="내용">
                </td>
                <td align="center">
                  <button class="btn btn-m"><i class="icon-check"></i></button>
                  <button class="btn btn-m ml-5"><i class="icon-close"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>



    </div>
  </div>
</template>
<script>
  import PageHeader from '@/layout/PageHeader.vue'
  import dropdown from "@/components/Dropdown.vue"

  export default {
    components: {
      PageHeader,
      dropdown
    },

    data() {
      return {
        tosList: null,
        assetList: null,
        checkList: null,
        isEnable: [
          {display: '비활성', value: 0},
          {display: '활성', value: 1}
        ],
        isRequired: [
          {display: '선택', value: 0},
          {display: '필수', value: 1}
        ],
        checkType: null
      }
    },
    created(){

    },
    mounted(){
      this.init();
    },
    computed: {
      // isEdit(){
      //   return (item) =>{
      //     return item.isEdit;
      //   }
      // },
    },
    methods: {
      init(){
        this.getTosList();
        this.getAssetList();
        this.getCheckList();
        this.getCheckType();
      },
      getTosList(){
        this.$http.get('/api/tos')
          .then((result) => {
            this.tosList = result.data;
          }).catch((e) =>{
          })
      },
      getAssetList(){
        this.$http.get('/api/public/asset')
          .then((result) => {
            this.assetList = result.data;
          }).catch((e) =>{
          })
      },
      getCheckList(){
        this.$http.get('/api/public/checkList')
          .then((result) => {
            this.checkList = result.data;
          }).catch((e) =>{
        })
      },
      getCheckType(){
        this.$http.get('/api/public/checkType')
          .then((result) => {
            this.checkType = result.data;
            this.checkType.forEach(x => {
              x.display = x.checkTypeStr;
              x.value = x.checkTypeCode;
            })
          }).catch((e) =>{
        })
      },


      addTos(){
        let obj = {
          tosTitle: '',
          tosAgreeText: '',
          tosContents: '',
          isRequired: 1,
          isEnable: 1
        };

        this.tosList.push(obj);
      }
    }
  }
</script>
<style>

</style>
